import AsyncStorage from '@react-native-async-storage/async-storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { PersistConfig } from 'redux-persist/es/types';

import { alarmReducer, AlarmSliceState } from '../features/alarm/store/slice';
import { appConfigReducer, AppConfigSliceState } from '../features/appconfig/store/slice';
import {
  bearerTokenReducer,
  BearerTokenSliceState,
} from '../features/bearertoken/store/slice';
import {
  currentPodcastReducer,
  CurrentPodcastSliceState,
} from '../features/currentpodcast/store/slice';
import {
  currentRadioReducer,
  CurrentRadioSliceState,
} from '../features/currentradio/store/slice';
import { CurrentTrack, currentTrackReducer } from '../features/currenttrack/store/slice';
import { liveFeedReducer, LiveFeedSliceState } from '../features/liveFeed/store/slice';
import { modalReducer, ModalSliceState } from '../features/modal/store/slice';
import { podcastReducer } from '../features/podcast/store/slice';
import {
  podcastListReducer,
  PodcastListSliceState,
} from '../features/podcastList/store/slice';
import { rawStreamReducer, RawStreamSliceState } from '../features/rawStream/store/slice';
import {
  textDedicationReducer,
  TextDedicationSliceState,
} from '../features/textDedication/store/slice';
import { webReducer, WebSliceState } from '../features/web/store/slice';

const webPersistConfig: PersistConfig<WebSliceState> = {
  key: 'webReducer',
  storage: AsyncStorage,
};

const appConfigPersistConfig: PersistConfig<AppConfigSliceState> = {
  key: 'appConfigReducer',
  storage: AsyncStorage,
};

const textDedicationPersistConfig: PersistConfig<TextDedicationSliceState> = {
  key: 'textDedicationReducer',
  storage: AsyncStorage,
};

const liveFeedPersistConfig: PersistConfig<LiveFeedSliceState> = {
  key: 'liveFeedReducer',
  storage: AsyncStorage,
};

const modalPersistConfig: PersistConfig<ModalSliceState> = {
  key: 'modalReducer',
  storage: AsyncStorage,
  blacklist: ['alert'],
};

const alarmPersistConfig: PersistConfig<AlarmSliceState> = {
  key: 'alarmReducer',
  storage: AsyncStorage,
};

const currentTrackPersistConfig: PersistConfig<CurrentTrack> = {
  key: 'currentTrackReducer',
  storage: AsyncStorage,
};

const currentRadioPersistConfig: PersistConfig<CurrentRadioSliceState> = {
  key: 'currentRadioReducer',
  storage: AsyncStorage,
};

const currentPodcastPersistConfig: PersistConfig<CurrentPodcastSliceState> = {
  key: 'currentPodcastReducer',
  storage: AsyncStorage,
};

const bearerTokenPersistConfig: PersistConfig<BearerTokenSliceState> = {
  key: 'bearerTokenReducer',
  storage: AsyncStorage,
};

const rawStreamPersistConfig: PersistConfig<RawStreamSliceState> = {
  key: 'rawStreamReducer',
  storage: AsyncStorage,
};

const podcastListPersistConfig: PersistConfig<PodcastListSliceState> = {
  key: 'podcastListReducer',
  storage: AsyncStorage,
};

export const rootReducer = combineReducers({
  webReducer: persistReducer(webPersistConfig, webReducer),
  appConfigReducer: persistReducer(appConfigPersistConfig, appConfigReducer),
  textDedicationReducer: persistReducer(
    textDedicationPersistConfig,
    textDedicationReducer,
  ),
  liveFeedReducer: persistReducer(liveFeedPersistConfig, liveFeedReducer),
  modalReducer: persistReducer(modalPersistConfig, modalReducer),
  alarmReducer: persistReducer(alarmPersistConfig, alarmReducer),
  currentTrackReducer: persistReducer(currentTrackPersistConfig, currentTrackReducer),
  currentRadioReducer: persistReducer(currentRadioPersistConfig, currentRadioReducer),
  currentPodcastReducer: persistReducer(
    currentPodcastPersistConfig,
    currentPodcastReducer,
  ),
  bearerTokenReducer: persistReducer(bearerTokenPersistConfig, bearerTokenReducer),
  rawStreamReducer: persistReducer(rawStreamPersistConfig, rawStreamReducer),
  podcastReducer,
  podcastListReducer: persistReducer(podcastListPersistConfig, podcastListReducer),
});

const rootPersistConfig: PersistConfig<ReturnType<typeof rootReducer>> = {
  key: 'root',
  storage: AsyncStorage,
  blacklist: [
    'webReducer',
    'appConfigReducer',
    'textDedicationReducer',
    'liveFeedReducer',
    'modalReducer',
    'alarmReducer',
    'currentTrackReducer',
    'currentRadioReducer',
    'currentPodcastReducer',
    'bearerTokenReducer',
    'rawStreamReducer',
    'podcastReducer',
    'podcastListReducer',
  ],
};

export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export type RootState = ReturnType<typeof persistedReducer>;
